import React from 'react'
import './simpleTooltips.css'

interface SimpleTooltipProps {
  step: {
    data: {
      content1: React.ReactNode
      content1Style?: string
    }
  }
  tooltipProps?: React.HTMLAttributes<HTMLDivElement>
}

export const SimpleTooltip = ({ step, tooltipProps }: SimpleTooltipProps) => {
  return (
    <div {...tooltipProps} className="simpleTooltip">
      <p className={step.data.content1Style || 'simpleTooltipText1'}>
        {step.data.content1}
      </p>
    </div>
  )
}
